<template>
  <transition name="nav-fade">
    <div v-if="menuActive" class="fixed w-screen h-screen top-0 left-0 pt-5 flex flex-col overflow-y-scroll" style="background:rgba(50, 55, 73, 1);z-index: 600;">
      <div @click="toggleMenu" class="close ml-4.5 mb-15 flex flex-col items-center w-max">
        <p class="uppercase font-medium fz-10 mb-4" style="line-height: 1 ;">{{ text.close }}</p>
        <div class="close relative  w-5 h-5">
          <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 origin-center rotate-45 h-2px w-5 bg-white"></div>
          <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 origin-center -rotate-45 h-2px w-5 bg-white"></div>
        </div>
      </div>
      <div class="langs ml-4.5 flex gap-15 mb-8">
        <div class="lang flex flex-col" :class="{'active': lang === 'ru'}" @click="setLang('ru')">
          <p class="font-semibold fz-13 mb-4.5 uppercase " style="line-height:1.538;">Русский</p>
          <div class=" h-2px" style="background:#FF2E53;"></div>
        </div>
        <div class="lang flex flex-col" :class="{'active': lang === 'ua'}" @click="setLang('ua')">
          <p class="font-semibold fz-13 mb-4.5 uppercase" style="line-height:1.538;">УКРАЇНСЬКА</p>
          <div class=" h-2px" style="background:#FF2E53;"></div>
        </div>
        <div class="lang flex flex-col" :class="{'active': lang === 'en'}" @click="setLang('en')">
          <p class="font-semibold fz-13 mb-4.5 uppercase" style="line-height:1.538;">ENGLISH</p>
          <div class=" h-2px" style="background:#FF2E53;"></div>
        </div>
      </div>
      <nav class="font-medium fz-18 uppercase flex flex-col justify-stretch gap-0.5 w-max mx-auto" style="line-height: 1.666;">
        <a href="#mobile-start" @click="setRoute('agency')" class="nav-item flex py-6 justify-between items-center">
          <p class="mr-22">{{ text.agency }}</p>
          <div class="plus relative w-4 h-4"></div>
        </a>
        <a href="#mobile-start" @click="setRoute('projects')" class="nav-item flex py-6 justify-between items-center">
          <p class="mr-22">{{ text.projects }}</p>
          <div class="plus relative w-4 h-4"></div>
        </a>
        <a href="#mobile-start" @click="setRoute('blog')" class="nav-item flex py-6 justify-between items-center">
          <p class="mr-22">{{ text.blog }}</p>
          <div class="plus relative w-4 h-4"></div>
        </a>
        <a href="#mobile-start" @click="toggleContacts" class="nav-item flex py-6 justify-between items-center">
          <p class="mr-22">{{ text.contacts }}</p>
          <div class="plus relative w-4 h-4"></div>
        </a>
      </nav>
      <div class="connect mt-auto py-6 flex justify-center items-center" @click="toggleContacts">
        <p class="uppercase fz-13 font-semibold mr-6" style="line-height: 1.538;">{{ text.contact }}</p>
        <div class="plus relative w-12.5 h-12.5 rounded-full" style="background:#fff;" >
          <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#000;"></div>
          <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#000;"></div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "menu",
  methods:{
    ...mapMutations(['setRoute', 'setLang', 'toggleMenu', 'toggleContacts'])
  },
  computed:{
    ...mapState(['menuActive', 'lang']),
    text(){
      return require('@/assets/text/menu/' + this.lang + '.json')
    },
  }
}
</script>

<style scoped lang="scss">
.nav-fade-enter-active,
.nav-fade-leave-active {
  transition: all 0.3s ease;
}

.nav-fade-enter-from,
.nav-fade-leave-to {
  left: -100vw;
}

.langs{
  *{
    transition: all linear 0.3s;
  }
  .lang{
      div{
        width: 0;
      }
    color: #6e758d;
  }

  .lang.active{
    color: white;
    div{
      width: 100%;
    }
  }
}
nav{
  .plus:before, .plus:after{
    content: "";
    background: #6e758d;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .plus:before{
    height: 2px;
    width: 1rem;
  }
  .plus:after{
    height: 1rem;
    width: 2px;
  }
}

.connect{
  background: radial-gradient(238.57% 87946.76% at 250.13% 0%, rgba(50, 55, 73, 0.4) 5.3%, rgba(0, 133, 255, 0.6) 18.49%, #FF2E53 100%);
}
</style>
